<!--
 * @Author: 汪俊洪
 * @Date: 2025-04-25 13:32:21
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-05-29 20:24:54
 * @Description:
-->
<template>
  <div class="page">
    <div class="content">
      <!-- 主体内容 -->
      <ListCart
        @refresh="doSearch"
        :tableData="[...tableData, ...invalidList]"
        :dataListLoading="loading"
      />
    </div>
  </div>
</template>

<script>
import ListCart from './components/listCart.vue'

export default {
  components: {
    ListCart
  },
  data () {
    return {
      tableData: [],
      invalidList: [], // 失效列表
      loading: false
    }
  },
  created () {
    this.doSearch()
  },
  methods: {
    doSearch () {
      const obj = {
        limit: 1000,
        page: 1
      }
      this.loading = true
      this.$http
        .post('/front/oms/plc/shoppingCart/pageShoppingCartSkuSkuList', obj)
        .then(({ data: res }) => {
          this.loading = false
          this.tableData = []
          this.invalidList = [] // 失效列表
          if (res.code === 0) {
            res.data.records.forEach((v) => {
              if (v.invalidStateSku) {
                this.invalidList.push(v)
              } else {
                this.tableData.push(v)
              }
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  padding: 16px 0;
}
.content {
  display: flex;
  flex-direction: column;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
}
</style>
